import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 只有 QUEUED 可取消。POST `/mom/work-order/{id}/sn-label-jobs/{jobId}/cancel` */
export async function cancelWorkOrderSnLabelJob(workOrderId, jobId) {
  const { data: raw } = await request.post(
    `/mom/work-order/${workOrderId}/sn-label-jobs/${jobId}/cancel`,
  );
  return parseVer4DetailResponse(raw);
}
